module.exports = __webpack_public_path__ + "static/media/whack.978de67b.mp3";